<template v-cloak>
    <NuxtLayout name="main" dark class="bg-[#F7F6FB]">
        <div class="mx-auto my-[56px] px-[64px] py-[62px] w-[1264px] bg-white">
            <div class="text-[44px] leading-[62px] font-bold text-emphas">{{ $t("AllInOneAccess") }}</div>
            <div class="w-[132px] h-[4px] bg-main mt-[22px] mb-[46px]"></div>
            <div
                class="mb-[40px] pl-[80px] h-[240px] flex flex-col justify-center bg-[url(https://rdgta.cdn.cyagen.com/rddc/pictures/4e8d41d7-0635-4aa7-af97-d015063ef32c.webp)] font-bold text-white">
                <div v-if="$i18n.locale == 'en'" class="text-[36px] leading-[52px] w-[660px]">
                    <p>{{ $t("AllInOneAccessI18n.Name1") }}</p>
                </div>
                <p v-else class="text-[40px] leading-[56px]">{{ $t("AllInOneAccessI18n.Name1") }}</p>
            </div>
            <p class="text-[16px]">{{ $t("AllInOneAccessI18n.Descript1") }}</p>
            <p class="text-[16px] mt-[24px] font-bold text-emphas">{{ $t("AllInOneAccessI18n.Descript2") }}</p>
            <p class="text-[16px]">{{ $t("AllInOneAccessI18n.Descript3") }}</p>
            <p class="text-[16px] mt-[24px] font-bold text-emphas">{{ $t("AllInOneAccessI18n.Descript4") }}</p>
            <p class="text-[16px]">{{ $t("AllInOneAccessI18n.Descript5") }}</p>
            <p class="text-[16px] mt-[24px] font-bold text-emphas">{{ $t("AllInOneAccessI18n.Descript6") }}</p>
            <p class="text-[16px]">{{ $t("AllInOneAccessI18n.Descript7") }}</p>
        </div>
    </NuxtLayout>
</template>
